'use client';

import { clsx } from 'clsx';
import { usePathname } from 'next/navigation';
import { FC, useState } from 'react';
import { BannerPromoStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import { Icon, IconType } from 'atoms/Icon';
import { OverLine } from 'atoms/Typography/Typography';
import { ReactMarkdown } from 'molecules/Markdown';
import { useMediaQuery } from 'modules/mui/hooks';
import { isValidDate, renderRichText } from 'modules/stroyblok/services';
import { Timer } from './Timer';
import styles from './styles.module.css';

export const PromoBanner: FC<{ blok: BannerPromoStoryblok }> = ({ blok }) => {
  const isValid = isValidDate(blok.start_date, blok.expiration_date);
  const { isMobile } = useMediaQuery();
  const pathname = usePathname();
  const isProductPage = pathname?.startsWith('/p/');
  const [showBanner, setShowBanner] = useState(true);
  const toggleBanner = () => setShowBanner((show) => !show);

  /** hide banner to prevent overlap with sticky footer */
  if (isProductPage && isMobile) {
    return null;
  }

  return !isValid || !showBanner ? null : (
    <div className={clsx(styles.root)}>
      <Container className={styles.container}>
        <div className={styles.content}>
          <Icon
            type={IconType.close}
            className={clsx(
              styles.closeButton,
              blok?.timer && styles.withTimer,
            )}
            onClick={toggleBanner}
          />

          <div
            className={styles.textWrapper}
            style={{ maxWidth: !!blok?.timer ? '75%' : '100%' }}
          >
            <ReactMarkdown
              text={
                renderRichText(
                  isMobile ? blok.mobileDescription : blok.desktopDescription,
                ) || ''
              }
              components={{
                p: ({ children }) => (
                  <OverLine type="md" className={styles.text}>
                    {children}
                  </OverLine>
                ),
              }}
            />
          </div>

          {blok?.timer && (
            <Timer _uid={blok._uid} timer={blok.timer} isValid={isValid} />
          )}
        </div>
      </Container>
    </div>
  );
};
